import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import { preloadEmojiTitle } from '@confluence/emoji-title/entry-points/preloadEmojiTitle';
import { preloadEditorPageCoverPicture } from '@confluence/page-cover-picture/entry-points/preloadEditorPageCoverPicture';

import { SmartCreatePageEditorDataWrapperComponentQuery } from './SmartCreatePageEditorDataWrapperComponentQuery.graphql';
import type {
	SmartCreatePageEditorDataWrapperComponentQuery as SmartCreatePageEditorDataWrapperComponentQueryType,
	SmartCreatePageEditorDataWrapperComponentQueryVariables,
} from './__types__/SmartCreatePageEditorDataWrapperComponentQuery';

const preloadEditorData = async (contentId: string) => {
	return query<
		SmartCreatePageEditorDataWrapperComponentQueryType,
		SmartCreatePageEditorDataWrapperComponentQueryVariables
	>({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: SmartCreatePageEditorDataWrapperComponentQuery,
		variables: {
			contentId,
		},
	});
};

export const preloadSmartCreateEditorData = async (contentId: string) => {
	return waitForAllReturnWhenError([
		preloadEditorData(contentId),
		preloadEmojiTitle(contentId, '', false),
		preloadEditorPageCoverPicture(contentId, '', false),
	]);
};
